import axios from "../utils/axios";

export function getTicketStepQuestionAnswers(ticketStepId) {
  const queryParams = new URLSearchParams({ ticketStepId });
  return axios.get(`/TicketStepQuestion/GetTicketStepQuestionAnswers?${queryParams}`);
}
